<div class="hk-check-directions">
  <ion-button expand="block" (click)="openInExternalMapApp()">
    <hk-wc-icon name="navigation-arrow" size="24" slot="start"></hk-wc-icon>
    Check directions
  </ion-button>
</div>
